import React, { useState, useContext } from "react";
import { Link, useLocation, Redirect } from "react-router-dom";
import { Icon, notification, Modal, Button, Collapse, Select, Dropdown, Menu } from "antd";

import { LuSend, LuCheck } from "react-icons/lu";

import DrawerDataEmissao from "../../Aproveitamento/Relatorios/Drawer/Ata";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import DrawerAdicionarParecer from "../Drawers/DrawerAdicionarParecer";
import FormDrawerAdicionarParecerAnual from "../Drawers/DrawerAdicionarParecerAnual";
import InitialsAvatar from "../../../shared/components/InitialsAvatar";
import moment from "moment";

import DrawerLogs from "../Drawers/DrawerLogs";

import SelectDisciplinas from "../componentes/SelectDisciplinas";

import axios from "axios";
import { useEffect } from "react";

import { GlobalContext } from "../../../app/providers/GlobalState";

const { Panel } = Collapse;
const { Option } = Select;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Pareceres = ({ match }) => {
    const [num, setNum] = useState(1);
    const [periodos, setPeriodos] = useState([]);
    const [periodo, setPeriodo] = useState({
        id: null,
        titulo: "",
        dtInicio: "",
        dtFim: ""
    });
    const [tituloParecer, setTituloParecer] = useState("");
    const [tituloParecerGeral, setTituloParecerGeral] = useState("");
    const [textoParecerGeral, setTextoParecerGeral] = useState("");
    const [textoParecerGeralRascunho, setTextoParecerGeralRascunho] = useState("");
    const [dtParecerGeralRascunho, setDtParecerGeralRascunho] = useState(null);
    const [drawerAdicionarParecerVisible, setDrawerAdicionarParecerVisible] = useState(false);
    const [drawerAdicionarParecerAnualVisible, setDrawerAdicionarParecerAnualVisible] = useState(false);
    const [visibleDrawerLogs, setVisibleDrawerLogs] = useState(false);

    const [parecer, setParecer] = useState({});
    const [participantes, setParticipantes] = useState([]);
    const [participantesAnual, setParticipantesAnual] = useState([]);
    const [docs, setDocs] = useState([]);
    const [dataEmissaoAlunoVisible, setDataEmissaoAlunoVisible] = useState(false);
    const [dataEmissaoAlunoAnualVisible, setDataEmissaoAlunoAnualVisible] = useState(false);
    const [anualCarregado, setAnualCarregado] = useState(false);

    const [parecerAnualBloqueado, setParecerAnualBloqueado] = useState(null);
    const [dataParecerAnualBloqueado, setDataParecerAnualBloqueado] = useState(null);

    const [dataEmissaoGeralAlunosVisible, setDataEmissaoGeralAlunosVisible] = useState(false);
    const [dataEmissaoGeralVisible, setDataEmissaoGeralVisible] = useState(false);
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [semPeriodos, setSemPeriodos] = useState(false);
    const [iconLoading, setIconLoading] = useState(false);
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [alunoId, setAlunoId] = useState();
    const [previousLocation, setPreviousLocation] = useState("");
    const [disciplinas, setDisciplinas] = useState([]);
    const [disciplinaId, setDisciplinaId] = useState(null);

    const [modalBloquearVisible, setModalBloquearVisible] = useState(false);
    const [modalDesbloquearVisible, setModalDesbloquearVisible] = useState(false);

    const anosEdicao = ["2022", "2023", "2024"];
    const cursoEdicao = localStorage.getItem("curso_edicao");
    const containsEdicao = anosEdicao.some(e => e === cursoEdicao);

    const isEIOuroBrancoAnosPosteriores =
        localStorage.getItem("header_codigo") === "EI" && localStorage.getItem("entidade_id") === "37" && !containsEdicao;

    const context = useContext(GlobalContext);

    const location = useLocation();

    const total = () => {
        setIconLoading(true);

        axios({
            method: "get",
            url: "/api/aulas/total-periodos-observacoes",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    setPeriodos(periodos);
                    setPeriodo({
                        id: response.data[0].id,
                        titulo: response.data[0].titulo,
                        dtInicio: response.data[0].dt_inicio,
                        dtFim: response.data[0].dt_fim
                    });
                } else {
                    setSemPeriodos(true);
                    setIconLoading(false);

                    openNotificationWithIcon("warning", "Atenção", "Não foram adicionados períodos ao curso!");
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    const listarDisciplinas = () => {
        setIconLoading(true);

        axios({
            method: "get",
            url: "/api/aulas/listar-turma-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (disciplinaId) {
                    const nomeDiscipinaSelecionada = disciplinas.find(d => d.id === disciplinaId).nome;
                    if (nomeDiscipinaSelecionada) setDisciplinaId(response.data.find(d => d.nome === nomeDiscipinaSelecionada).id);
                    else setDisciplinaId(null);
                }

                setDisciplinas(response.data);
                setIconLoading(false);
            })
            .catch(error => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar as disciplinas!");
            });
    };

    const handleSelect = opcao => {
        const disciplinaIdLocal = opcao;

        setDisciplinaId(disciplinaIdLocal);
    };

    const selectDiscipline = opcao => {
        handleSelect(opcao);
    };

    const carregarPareceresAlunos = () => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-pareceres-alunos",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodo.id
            }
        })
            .then(response => {
                setParticipantes(response.data);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const carregarParecerGeral = () => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-parecer-geral",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodo.id
            }
        })
            .then(response => {
                setTextoParecerGeral(response.data.parecer_geral);
                setTextoParecerGeralRascunho(response.data.parecer_geral_rascunho);
                setDtParecerGeralRascunho(response.data.dt_parecer_rascunho);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o parecer geral!");
            });
    };

    const carregarParecerAnual = () => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-parecer-anual",
            params: {
                turmaId: !disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId
            }
        })
            .then(response => {
                const participantes = response.data.participantes;
                const parecerAnualBloqueado = response.data.parecerAnualBloqueado;
                const dataParecerAnualBloqueado = response.data.dataParecerAnualBloqueado;

                setDataParecerAnualBloqueado(dataParecerAnualBloqueado);
                setParticipantesAnual(participantes);
                setParecerAnualBloqueado(parecerAnualBloqueado);
                setAnualCarregado(true);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const alterarAcessoParecerAnual = acesso => {
        axios({
            method: "put",
            url: "/api/pareceres/bloquear-parecer-anual",
            params: {
                cursoId: !disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId,
                acesso
            }
        })
            .then(response => {
                setParecerAnualBloqueado(acesso);
                setDataParecerAnualBloqueado(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível bloquear os pareceres!");
            });
    };

    const tituloPareceres = () => {
        axios({
            method: "get",
            url: "/api/pareceres/titulo-parecer",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setTituloParecer(response.data.parecer);
                setTituloParecerGeral(response.data.parecerGeral);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o parecer geral!");
            });
    };

    const anteriorProximo = num => {
        var periodo = periodos[num - 1];

        setNum(num);
        setPeriodo({
            id: periodo.id,
            titulo: periodo.titulo,
            dtInicio: periodo.dt_inicio,
            dtFim: periodo.dt_fim
        });
        setIconLoading(true);
    };

    const guardar = texto => {
        if (parecer.participante?.id == null) setTextoParecerGeral(texto);
        else {
            let tempParticipantes = participantes;
            const index = tempParticipantes.findIndex(x => x.id === parecer.participante?.id);

            tempParticipantes[index].parecer = texto;
            setParticipantes([...tempParticipantes]);
        }
    };

    const guardarAnual = texto => {
        let tempParticipantes = participantesAnual;
        const index = tempParticipantes.findIndex(x => x.id === parecer.participante?.id);

        tempParticipantes[index].parecer_anual = texto;
        setParticipantesAnual([...tempParticipantes]);
    };

    const descarregarParecerDescritivoTurma = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-turma",
            params: {
                utilizadorId: alunoId,
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodo.id,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setVisibleViewer(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível descarregar o documento!");

                setVisibleLoading(false);
            });
    };

    const exportarParecerGeralAlunos = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-alunos-geral",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodo.id,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setVisibleViewer(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setVisibleLoading(false);
            });
    };

    const exportarGeraisPdf = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-turma-geral",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodo.id,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setVisibleViewer(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setVisibleLoading(false);
            });
    };

    const exportarAnualPdf = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-anual",
            params: {
                turmaId: !disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId,
                utilizadorId: alunoId,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setVisibleLoading(false);
            });
    };

    useEffect(() => {
        tituloPareceres();
        if (location.pathname !== previousLocation.pathname) {
            total();
            listarDisciplinas();
            if (localStorage.getItem("entidade_id") === "37") {
                carregarParecerAnual();
            }
        }

        setPreviousLocation(location);
    }, [location.pathname]);

    useEffect(() => {
        if (localStorage.getItem("entidade_id") === "37") {
            carregarParecerAnual();
        }
    }, [disciplinaId]);

    useEffect(() => {
        if (periodo.id) {
            carregarPareceresAlunos();
            carregarParecerGeral();
        }
    }, [periodo]);

    const acesso = context.acessos?.find(x => x.func === 30);
    const pareceresAcesso = context.acessos?.find(x => x.func === 31);

    return (
        <>
            <div className="container container-body">
                <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                    <h3 className="titulo-bloco">Pareceres</h3>
                    <div className="bloco-opcoes-esquerda">
                        <Link
                            to={`/gerir-multisseriado/${match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                            }`}
                            className="botao-secundario botao-secundario-redondo"
                            title="Voltar"
                            style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>

                {localStorage.getItem("entidade_id") === "37" &&
                    anualCarregado &&
                    (participantesAnual?.length > 0 ? (
                        <div className="curso-diario">
                            <div className="bloco-controlos-frequencia">
                                <div className="filters-parecer">
                                    <SelectDisciplinas disciplinas={disciplinas} onChange={selectDiscipline} visible />
                                    {isEIOuroBrancoAnosPosteriores && (
                                        <div className="controlos controlos-fundo ">
                                            <div className="bloco-esquerda"></div>
                                            <div className="bloco-direita">
                                                {pareceresAcesso?.read && !parecerAnualBloqueado && (
                                                    <Link
                                                        className="botao-icon-bloquear"
                                                        to={"#"}
                                                        title="Pareceres"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setModalBloquearVisible(true);
                                                        }}
                                                    >
                                                        <LuSend />
                                                        Finalizar e Entregar Pareceres
                                                    </Link>
                                                )}
                                                {parecerAnualBloqueado && (
                                                    <div style={{ display: "flex", gap: 5 }}>
                                                        <LuCheck style={{ color: "green", fontSize: 20 }} />
                                                        Entregue em {moment(dataParecerAnualBloqueado).format("DD/MM/YYYY")}
                                                    </div>
                                                )}
                                                {pareceresAcesso?.update && parecerAnualBloqueado && (
                                                    <>
                                                        <Link
                                                            className="botao-icon-desbloquear"
                                                            to={"#"}
                                                            title="Pareceres"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                setModalDesbloquearVisible(true);
                                                            }}
                                                        >
                                                            <Icon type="unlock" />
                                                            Reabrir para Edição
                                                        </Link>
                                                        <Dropdown
                                                            overlay={() => (
                                                                <Menu>
                                                                    <Menu.Item>
                                                                        <Link
                                                                            to="#"
                                                                            onClick={e => {
                                                                                e.preventDefault();
                                                                                setVisibleDrawerLogs(true);
                                                                            }}
                                                                        >
                                                                            Logs
                                                                        </Link>
                                                                    </Menu.Item>
                                                                </Menu>
                                                            )}
                                                            placement="bottomLeft"
                                                        >
                                                            <Link to="#" className="botao-icon-configs">
                                                                <i className="fas fa-cog" />
                                                            </Link>
                                                        </Dropdown>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes">
                                <Panel
                                    header={
                                        <span
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%"
                                            }}
                                        >
                                            <label>Parecer Descritivo Anual</label>
                                        </span>
                                    }
                                    key="1"
                                >
                                    <div className="bloco-diario-observacoes">
                                        <ul className="lista-observacoes">
                                            {participantesAnual?.map(participante => (
                                                <li key={participante.id} className="item-observacoes">
                                                    <div
                                                        className="info-participante"
                                                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                                    >
                                                        <div className="container-img">
                                                            {participante.foto ? (
                                                                <img src={participante.foto} />
                                                            ) : (
                                                                participante.nome !== "" && <InitialsAvatar name={participante.nome} />
                                                            )}
                                                        </div>
                                                        <div className="info" style={{ flex: "fit-content" }}>
                                                            <span className="nome">{participante.nome}</span>
                                                            <p className="numero">{participante.numero}</p>
                                                        </div>
                                                        <div className="bloco-opcoes-esquerda" style={{ display: "flex", gap: 5 }}>
                                                            {acesso?.update && !parecerAnualBloqueado && (
                                                                <Link
                                                                    to="#"
                                                                    className="botao-icon-editar"
                                                                    title="Editar"
                                                                    onClick={event => {
                                                                        event.stopPropagation();
                                                                        setDrawerAdicionarParecerAnualVisible(true);
                                                                        setParecer({
                                                                            participante
                                                                        });
                                                                    }}
                                                                >
                                                                    <Icon type="edit" />
                                                                </Link>
                                                            )}

                                                            <Link
                                                                className="botao-icon-parecer-aluno"
                                                                to="#"
                                                                title="Visualizar"
                                                                onClick={event => {
                                                                    event.stopPropagation();
                                                                    setAlunoId(participante.id);
                                                                    setDataEmissaoAlunoAnualVisible(true);
                                                                }}
                                                            >
                                                                <Icon type="profile" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                    <p dangerouslySetInnerHTML={{ __html: participante.parecer_anual }}></p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                    ) : (
                        <Redirect
                            to={`/gerir-multisseriado/${match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                            }`}
                        />
                    ))}

                {!isEIOuroBrancoAnosPosteriores && (
                    <div className="curso-diario">
                        <div className="bloco-controlos-frequencia">
                            <div className="filters" style={{ display: "flex", justifyContent: "center" }}>
                                {!semPeriodos && (
                                    <div>
                                        <Button
                                            className="botao-periodo botao-periodo-anterior"
                                            disabled={num === 1}
                                            style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                            onClick={() => anteriorProximo(num - 1)}
                                        >
                                            <Icon type="left" />
                                        </Button>
                                        <span>{periodo.titulo}</span>
                                        <Button
                                            className="botao-periodo botao-periodo-proximo"
                                            disabled={num === periodos.length}
                                            style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                            onClick={() => anteriorProximo(num + 1)}
                                        >
                                            <Icon type="right" />
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes">
                            <Panel
                                header={
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        }}
                                    >
                                        <label>{tituloParecer}</label>
                                        <span style={{ display: "flex", gap: 10 }}>
                                            <Link
                                                className="botao-icon-detalhe"
                                                to="#"
                                                title="Visualizar"
                                                onClick={event => {
                                                    event.stopPropagation();

                                                    if (localStorage.getItem("entidade_id") === "33") {
                                                        setDataEmissaoGeralAlunosVisible(true);
                                                    } else {
                                                        exportarParecerGeralAlunos();
                                                    }
                                                }}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                        </span>
                                    </span>
                                }
                                key="1"
                            >
                                <div className="bloco-diario-observacoes">
                                    <ul className="lista-observacoes">
                                        {participantes.map(participante => (
                                            <li key={participante.id} className="item-observacoes">
                                                <div
                                                    className="info-participante"
                                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                                >
                                                    <div className="container-img">
                                                        {participante.foto ? (
                                                            <img src={participante.foto} />
                                                        ) : (
                                                            participante.nome !== "" && <InitialsAvatar name={participante.nome} />
                                                        )}
                                                    </div>
                                                    <div className="info" style={{ flex: "fit-content" }}>
                                                        <span className="nome">{participante.nome}</span>
                                                        <p className="numero">{participante.numero}</p>
                                                    </div>
                                                    <div className="bloco-opcoes-esquerda" style={{ display: "flex", gap: 5 }}>
                                                        {acesso?.update && (
                                                            <Link
                                                                to="#"
                                                                className="botao-icon-editar"
                                                                title="Editar"
                                                                onClick={event => {
                                                                    event.stopPropagation();
                                                                    setDrawerAdicionarParecerVisible(true);
                                                                    setParecer({
                                                                        participante
                                                                    });
                                                                }}
                                                            >
                                                                <Icon type="edit" />
                                                            </Link>
                                                        )}
                                                        <Link
                                                            className="botao-icon-parecer-aluno"
                                                            to="#"
                                                            title="Visualizar"
                                                            onClick={event => {
                                                                event.stopPropagation();
                                                                setAlunoId(participante.id);
                                                                setDataEmissaoAlunoVisible(true);
                                                            }}
                                                        >
                                                            <Icon type="profile" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <p dangerouslySetInnerHTML={{ __html: participante.parecer }}></p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Panel>
                            <Panel
                                header={
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        }}
                                    >
                                        <label>{tituloParecerGeral}</label>
                                        <span style={{ display: "flex", gap: 10 }}>
                                            {acesso?.update && (
                                                <Link
                                                    to="#"
                                                    className="botao-icon-editar"
                                                    title="Editar"
                                                    onClick={event => {
                                                        event.stopPropagation();
                                                        setDrawerAdicionarParecerVisible(true);
                                                        setParecer({
                                                            textoParecerGeral,
                                                            textoParecerGeralRascunho,
                                                            dtParecerGeralRascunho
                                                        });
                                                    }}
                                                >
                                                    <Icon type="edit" />
                                                </Link>
                                            )}
                                            <Link
                                                className="botao-icon-detalhe"
                                                to="#"
                                                title="Visualizar"
                                                onClick={event => {
                                                    event.stopPropagation();

                                                    if (localStorage.getItem("entidade_id") === "33") {
                                                        setDataEmissaoGeralVisible(true);
                                                    } else {
                                                        exportarGeraisPdf();
                                                    }
                                                }}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                        </span>
                                    </span>
                                }
                                key="2"
                            >
                                <div className="bloco-diario-observacoes">
                                    {textoParecerGeral ? (
                                        <p className="observacao-geral" dangerouslySetInnerHTML={{ __html: textoParecerGeral }}></p>
                                    ) : (
                                        <p className="observacao-geral">Sem dados...</p>
                                    )}
                                </div>
                            </Panel>
                        </Collapse>
                    </div>
                )}
            </div>
            <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                <div className="modal-loading-bloco">
                    <p>
                        <Icon type="loading" />
                    </p>
                    <p className="texto">A carregar...</p>
                </div>
            </Modal>

            <Modal
                visible={modalBloquearVisible}
                title="Finalizar e Entregar"
                okText="Confirmar"
                cancelText="Cancelar"
                onCancel={() => setModalBloquearVisible(false)}
                onOk={() => {
                    // lógica de bloquear aqui
                    alterarAcessoParecerAnual(true);
                    setModalBloquearVisible(false);
                }}
            >
                <p>
                    Tem a certeza que pretende finalizar e entregar estes pareceres? Após a entrega, os campos ficarão bloqueados para
                    edição.
                </p>
            </Modal>

            <Modal
                visible={modalDesbloquearVisible}
                title="Reabrir para Edição"
                okText="Confirmar"
                cancelText="Cancelar"
                onCancel={() => setModalDesbloquearVisible(false)}
                onOk={() => {
                    // lógica de desbloquear aqui
                    alterarAcessoParecerAnual(false);
                    setModalDesbloquearVisible(false);
                }}
            >
                <p>Tem a certeza que pretende reabrir os pareceres para edição?</p>
            </Modal>

            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />

            <DrawerLogs
                turmaId={!disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId}
                visible={visibleDrawerLogs}
                onClose={() => setVisibleDrawerLogs(false)}
            />

            <DrawerDataEmissao
                visible={dataEmissaoAlunoVisible}
                onClose={() => setDataEmissaoAlunoVisible(false)}
                onConfirm={dataEmissao => {
                    descarregarParecerDescritivoTurma(dataEmissao);
                    setDataEmissaoAlunoVisible(false);
                }}
            />
            <DrawerDataEmissao
                visible={dataEmissaoAlunoAnualVisible}
                onClose={() => setDataEmissaoAlunoAnualVisible(false)}
                onConfirm={dataEmissao => {
                    exportarAnualPdf(dataEmissao);
                    setDataEmissaoAlunoAnualVisible(false);
                }}
            />
            <DrawerDataEmissao
                visible={dataEmissaoGeralAlunosVisible}
                onClose={() => setDataEmissaoGeralAlunosVisible(false)}
                onConfirm={dataEmissao => {
                    exportarParecerGeralAlunos(dataEmissao);
                    setDataEmissaoGeralAlunosVisible(false);
                }}
            />
            <DrawerDataEmissao
                visible={dataEmissaoGeralVisible}
                onClose={() => setDataEmissaoGeralVisible(false)}
                onConfirm={dataEmissao => {
                    exportarGeraisPdf(dataEmissao);
                    setDataEmissaoGeralVisible(false);
                }}
            />

            <DrawerAdicionarParecer
                onRascunhoGuardado={(alunoId, rascunho, dtRascunho) => {
                    setParticipantes(prev =>
                        prev.map(p =>
                            p.id === alunoId
                                ? {
                                      ...p,
                                      parecer_rascunho: rascunho,
                                      dt_parecer_rascunho: dtRascunho
                                  }
                                : p
                        )
                    );
                }}
                onRascunhoGeralGuardado={(rascunho, dtRascunho) => {
                    setTextoParecerGeralRascunho(rascunho);
                    setDtParecerGeralRascunho(dtRascunho);
                    setParecer(prev => ({
                        ...prev,
                        textoParecerGeralRascunho: rascunho,
                        dtParecerGeralRascunho: dtRascunho
                    }));
                }}
                disciplinaId={localStorage.getItem("codigo_curso")}
                parecerInfo={parecer}
                apagarRascunnhoGeral={() => {
                    setTextoParecerGeralRascunho(null);
                    setDtParecerGeralRascunho(null);
                    setParecer(prev => ({
                        ...prev,
                        textoParecerGeralRascunho: null,
                        dtParecerGeralRascunho: null
                    }));
                }}
                apagarRascunnhoParticipante={() => {
                    setParticipantes(prev => prev.map(p => (p.id === parecer.participante?.id ? { ...p, parecer_rascunho: null } : p)));
                }}
                periodoId={periodo.id}
                visible={drawerAdicionarParecerVisible}
                onClose={() => setDrawerAdicionarParecerVisible(false)}
                onConfirm={texto => {
                    guardar(texto);
                    setParticipantes(prev => prev.map(p => (p.id === parecer.participante?.id ? { ...p, parecer_rascunho: null } : p)));
                    setDrawerAdicionarParecerVisible(false);
                }}
            />

            <FormDrawerAdicionarParecerAnual
                disciplinaId={!disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId}
                parecerInfo={parecer}
                visible={drawerAdicionarParecerAnualVisible}
                onClose={() => setDrawerAdicionarParecerAnualVisible(false)}
                onRascunhoGuardado={(alunoId, rascunho, dtRascunho) => {
                    setParticipantesAnual(prev =>
                        prev.map(p =>
                            p.id === alunoId
                                ? {
                                      ...p,
                                      parecer_anual_rascunho: rascunho,
                                      dt_parecer_anual_rascunho: dtRascunho
                                  }
                                : p
                        )
                    );
                }}
                onConfirm={texto => {
                    guardarAnual(texto);
                    setParticipantesAnual(prev =>
                        prev.map(p => (p.id === parecer.participante?.id ? { ...p, parecer_anual_rascunho: null } : p))
                    );
                    setDrawerAdicionarParecerAnualVisible(false);
                }}
            />
        </>
    );
};

export default Pareceres;
